import { bsConstants, CategoryDto } from 'booksprout'

/** Everything this needs off a category, so callers can pass a partial one. */
export type NameableCategory = Pick<CategoryDto, 'name'> & Partial<Pick<CategoryDto, 'translations'>>

/**
 * A category's name in the reader's language.
 *
 * `name` is always the English source of truth and the translations are machine-written by the
 * API, so anything not translated yet - a category added this morning, or one an admin has just
 * renamed - falls back to English rather than showing a stale word or a blank.
 */
export function categoryName (category: NameableCategory, locale?: string | null): string {
  // `|| ''` throughout because a category name is nullable in practice, and this feeds
  // localeCompare as well as the templates.
  if (!locale || locale === bsConstants.I18N.DEFAULT_LOCALE) {
    return category.name || ''
  }

  const translation = category.translations?.find(entry => entry.locale === locale)

  return translation?.name || category.name || ''
}
